import './MultiMeterBarChartOverlay.css';
export var container = '_icd2920-2-0-1';